import { format } from 'date-fns';

/**
 * Format a date coming from the API without ever throwing.
 *
 * `date-fns`'s `format()` raises `RangeError: Invalid time value` when it
 * receives an `Invalid Date`. That happens whenever a field the UI expects is
 * absent or not a date (for example `user_group_members` has `createdAt` but
 * no `addedAt`, so `m.addedAt` is `undefined`). A missing timestamp must
 * degrade to a placeholder, never break a whole dialog.
 */
export function formatDateSafe(
  value: unknown,
  pattern: string,
  fallback = '—',
): string {
  if (value === null || value === undefined || value === '') return fallback;

  const date = value instanceof Date ? value : new Date(value as string | number);
  if (Number.isNaN(date.getTime())) return fallback;

  return format(date, pattern);
}
